export function moveItemInArray<T>(data: T[], from: number, to: number): T[] {
  // remove `from` item and store it
  var f = data.splice(from, 1)[0];
  // insert stored item into position `to`
  data.splice(to, 0, f);
  return data;
}

export function countOccurances<T>(data: T[], el: T): number {
  var count = 0;
  for(var i = 0; i < data.length; i++) {
    if(data[i] == el) {
      count+=1;
    }
  }
  return count;
}

export function removeDoubleElements<T>(data: T[]): T[] {
  var newArray:T[] = [];
  for(var i = 0; i < data.length; i++) {
    if(!newArray.includes(data[i])) {
      newArray.push(data[i]);
    }
  }
  return newArray;
}

export function removeLastOccurrance<T>(data: T[], el: T): T[] {
  if(data.length == 1) return [];
  for(var i = data.length-1; i >= 0; i--) {
    if(data[i] == el) {
      data.splice(i, 1);
      return data;
    }
  }
  return data;
}

export function removeAllOccurances<T>(data: T[], el: T): T[] {
  var newData = [...data];
  while(countOccurances(newData, el) > 0) {
    newData = removeLastOccurrance(data, el);
  }
  return newData;
}

export function setAmount<T>(data: T[], el: T, amount: number): T[] {
  const newArray:T[] = [];
  if(countOccurances(data, el) > amount) {
    return setAmount(removeLastOccurrance(data, el), el, amount);
  }else if(countOccurances(data, el) < amount) {
    const newData = [...data];
    newData.push(el);
    return setAmount(newData, el, amount);
  }
  return data;
}


interface LinearPartitionResult {
  partitions: number[][];
}

function linearPartition(nums: number[], r: number): number[][] {
  const n = nums.length;
  if (r <= 0) return [];
  if (r >= n) return nums.map(x => [x]);

  // Prefix sums for quick range sum calculation
  const prefix: number[] = [0];
  for (let i = 0; i < n; i++) prefix.push(prefix[i] + nums[i]);

  // DP tables
  const dp: number[][] = Array.from({ length: n + 1 }, () => Array(r + 1).fill(Infinity));
  const div: number[][] = Array.from({ length: n + 1 }, () => Array(r + 1).fill(0));
  dp[0][0] = 0;

  for (let i = 1; i <= n; i++) {
    dp[i][1] = prefix[i];
  }
  for (let k = 2; k <= r; k++) {
    for (let i = 1; i <= n; i++) {
      for (let j = k - 1; j < i; j++) {
        const cost: number = Math.max(dp[j][k - 1], prefix[i] - prefix[j]);
        if (dp[i][k] > cost) {
          dp[i][k] = cost;
          div[i][k] = j;
        }
      }
    }
  }

  // Reconstruct the partition
  function reconstructPartitions(n: number, k: number): number[][] {
    if (k === 1) return [nums.slice(0, n)];
    const result = reconstructPartitions(div[n][k], k - 1);
    result.push(nums.slice(div[n][k], n));
    return result;
  }

  return reconstructPartitions(n, r);
}

export {linearPartition}


export function shuffle(array: any[]) {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
}

interface SwapDefinition {
  length: number;
  [index: number]: number;
}

export function rearrangeArrayByPattern<T>(arr: T[], swapDefinition: SwapDefinition): T[] {
  const result: T[] = [];
  const groupSize = swapDefinition.length;
  for (let i = 0; i < arr.length; i += groupSize) {
    for (let j = 0; j < groupSize && (i + j) < arr.length; j++) {
      result[i + swapDefinition[j]] = arr[i + j];
    }
  }
  return result;
}